/**
 * Pulse Diagnosis Page — Interactive Components
 * - FAQ accordion (open/close with aria)
 * - Stats counter animation on scroll
 * - Testimonial swipe (mobile)
 */
(function () {
  'use strict';

  /* ── FAQ ACCORDION ── */
  function initAccordion() {
    var headers = document.querySelectorAll('.pd-accordion__header');
    if (!headers.length) return;

    headers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pd-accordion__item');
        var body = item.querySelector('.pd-accordion__body');
        if (!body) return;

        var isOpen = body.classList.contains('is-open');

        if (isOpen) {
          body.style.maxHeight = body.scrollHeight + 'px';
          requestAnimationFrame(function () {
            body.style.maxHeight = '0';
          });
          body.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          body.classList.add('is-open');
          body.style.maxHeight = body.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');

          body.addEventListener('transitionend', function handler() {
            body.style.maxHeight = '';
            body.removeEventListener('transitionend', handler);
          });
        }
      });
    });
  }

  /* ── STATS COUNTER ANIMATION ── */
  function initStatsCounter() {
    var statsSection = document.querySelector('.pd-stats');
    if (!statsSection) return;

    var statEls = statsSection.querySelectorAll('.pd-stat');
    var animated = false;

    function animateNumbers() {
      if (animated) return;
      animated = true;

      statEls.forEach(function (el) {
        var numberEl = el.querySelector('.pd-stat__number');
        if (!numberEl) return;

        var finalText = numberEl.textContent.trim();
        var target = parseInt(el.getAttribute('data-target'), 10);
        if (isNaN(target)) return;

        var duration = 2000;
        var startTime = null;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.floor(eased * target);

          if (target >= 1000000) {
            numberEl.textContent = (current / 1000000).toFixed(1).replace('.', ',') + ' milijono';
          } else if (target >= 50) {
            numberEl.textContent = current + '+';
          } else {
            numberEl.textContent = current.toString();
          }

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            numberEl.textContent = finalText;
          }
        }

        requestAnimationFrame(step);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateNumbers();
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      observer.observe(statsSection);
    } else {
      animateNumbers();
    }
  }

  /* ── TESTIMONIAL SWIPE (mobile) ── */
  function initTestimonialSwipe() {
    var grid = document.querySelector('.pd-testimonials__grid');
    if (!grid) return;

    var cards = grid.querySelectorAll('.pd-col');
    if (cards.length < 2) return;

    var currentSlide = 0;
    var startX = 0;
    var diffX = 0;

    function isMobile() { return window.innerWidth <= 767; }

    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx >= cards.length) idx = cards.length - 1;
      currentSlide = idx;
      if (isMobile()) {
        grid.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
      } else {
        grid.style.transform = '';
      }
    }

    grid.addEventListener('touchstart', function (e) {
      if (!isMobile()) return;
      startX = e.touches[0].clientX;
    }, { passive: true });

    grid.addEventListener('touchmove', function (e) {
      if (!isMobile()) return;
      diffX = e.touches[0].clientX - startX;
    }, { passive: true });

    grid.addEventListener('touchend', function () {
      if (!isMobile()) return;
      if (Math.abs(diffX) > 50) {
        goTo(diffX < 0 ? currentSlide + 1 : currentSlide - 1);
      }
      diffX = 0;
    });

    window.addEventListener('resize', function () {
      goTo(isMobile() ? currentSlide : 0);
    });
  }

  /* ── SMOOTH SCROLL FOR ANCHOR LINKS ── */
  function initSmoothScroll() {
    document.querySelectorAll('.pd-page a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── INIT ALL ── */
  function init() {
    initAccordion();
    initStatsCounter();
    initTestimonialSwipe();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
